import React, {useMemo, useState} from 'react';
import {TextButton, TextButtonPriority, Text, TextPriority} from 'wix-ui-tpa/cssVars';
import {ChevronUp, ChevronDown} from '@wix/wix-ui-icons-common/on-stage';
import {classes} from './AdditionalDetailsStepOpen.st.css';

export enum AdditionalDetailsFormSubtitleDataHook {
  descriptionContainer = 'AdditionalDetailsFormSubtitleDataHook.descriptionContainer',
  descriptionListItem = 'AdditionalDetailsFormSubtitleDataHook.descriptionListItem',
  collapseExpandButton = 'AdditionalDetailsFormSubtitleDataHook.collapseExpandButton',
}

export const AdditionalDetailsFormSubtitle: React.FC<{description: string[]}> = ({description}) => {
  const [isCollapsed, setIsCollapsed] = useState(true);

  const descriptionToShow = useMemo(
    () => (isCollapsed ? description.slice(0, 3) : description),
    [description, isCollapsed]
  );

  const shouldShowCollapseExpandButton = useMemo(() => description.length > 3, [description]);

  const onCollapseExpandClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setIsCollapsed(!isCollapsed);
  };

  if (!descriptionToShow.length) {
    return null;
  }

  return (
    <div className={classes.descriptionContainer}>
      <ul className={classes.options}>
        {descriptionToShow.map((description) => (
          <li key={`description-${description}`} data-hook={AdditionalDetailsFormSubtitleDataHook.descriptionListItem}>
            <Text priority={TextPriority.secondary}>{description}</Text>
          </li>
        ))}
      </ul>

      {shouldShowCollapseExpandButton && (
        <TextButton
          className={classes.collapseButton}
          suffixIcon={isCollapsed ? <ChevronDown /> : <ChevronUp />}
          priority={TextButtonPriority.secondary}
          data-hook={AdditionalDetailsFormSubtitleDataHook.collapseExpandButton}
          onClick={onCollapseExpandClick}>
          {isCollapsed ? '**Show More**' : '**Show Less**'}
        </TextButton>
      )}
    </div>
  );
};
